import cx from 'classnames';
import { useEffect, useState } from 'react';
import { Modal, Button, ModalTitle, Row, Col } from 'react-bootstrap';
import { BigButton, MiniButton } from './';
import { icons } from '../assets';
import _ from 'lodash';
import FooterButton from './FooterButton';
import { usePermissionsHandler } from '../hooks/usePermissions';
import { useCustomKeyPress } from '../hooks/useCustomKeyPress';
const { CloseIconSmall, ExpandIcon, CloseIcon2 } = icons;

export const ModalArea = (props) => {
  useCustomKeyPress({
    callback: props?.promptButton?.props?.onClick,
    active: props.showModal && props.promptButton,
  });

  function handleClose() {
    if (props?.isCloseModal) {
      props.onCloseModal();
    } else {
      if (props.ownerModal) {
        props.handleOwnerClose();
      }

      props.setShowModal(false);
    }
  }
  return (
    <Modal
      id="pop-up-body"
      show={props.showModal}
      className={props.parentClassName}
      animation={props.animation || false}
      onHide={handleClose}
      enforceFocus={'enforceFocus' in props ? props.enforceFocus : true}
      size={props?.size || 'md'}
      centered={props.centered}
      backdrop={props?.backdrop}
      backdropClassName={props?.backdropClassName}
      contentClassName={props?.contentClassName}
      dialogClassName={cx('lf-modal-default', props.className || 'new-item-modal')}
      style={props.style}>
      {props?.expandAndCenter ? (
        <Button
          onClick={props?.expandAndCenter}
          className="modalCloseButton lf-modal-expand-button">
          <ExpandIcon />
        </Button>
      ) : null}
      {props?.headerActions ? (
        <div
          style={{
            position: 'absolute',
            top: '1rem',
            right: '4.25rem',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}>
          {props.headerActions}
        </div>
      ) : null}
      {!props?.hideCloseButton ? (
        <Button
          onClick={handleClose}
          className={`modalCloseButton lf-modal-close-button ${
            props?.closeIconV2 ? 'modalCloseButtonV2' : ''
          }`}
          style={props.closeBtnStyle}>
          {props?.closeIconV2 ? (
            <CloseIcon2 style={props?.closeBtnStyle} />
          ) : (
            <CloseIconSmall style={props?.closeBtnStyle} />
          )}
        </Button>
      ) : null}
      {props.title && (
        <ModalTitle
          className={`${props.headingLeft ? 'text-start' : 'text-center'} ${
            props.headingClassName || ''
          }`}>
          {props.title}
        </ModalTitle>
      )}
      {props.subtitle && <span className="lf-modal-subtitle mb-4">{props.subtitle}</span>}
      {props?.qrTitle && <span className="lf-modal-qrtitle mb-4">{props?.qrTitle}</span>}
      {props.body && <Modal.Body className={props.bodyClassName}>{props.body}</Modal.Body>}
      {props.includeCancelButton || props.promptButton ? (
        <Modal.Footer className="commonPopupFooter p-0">
          {props.includeCancelButton && (
            <BigButton
              className={`${props.cancelBtnClassname || 'lf-btn-1'} keep-text`}
              buttonTitle={props.cancelTitle || 'Cancel'}
              onClick={handleClose}
            />
          )}
          {props.promptButton}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

const ModalButtonArea = (props) => {
  const { handlePermissionEvent } = usePermissionsHandler();
  const [showModal, setShowModal] = useState(
    _.isBoolean(props.startOpen) ? props.startOpen : false
  );
  // need to get styling working properly here

  function toggleModal(overrideValue) {
    if (props?.preventFromClosing) return;
    if (props?.setShowModal && props?.bigIcon) {
      props?.setShowModal?.(false);
      return;
    }
    if (_.isBoolean(props.showModal)) {
      props.setShowModal(overrideValue);
    } else {
      setShowModal(overrideValue);
    }
    if (_.isFunction(props.onClose) && !overrideValue) {
      props.onClose();
    }
  }

  const openModal = () => {
    toggleModal(true);
  };

  // useEffect(()=>{
  //   if(props?.isBlur && showModal){
  //     document.body.classList.add('modal-backdrop-open')
  //   }else{
  //     document.body.classList.remove('modal-backdrop-open')
  //   }
  // }, [showModal,props?.isBlur])

  return (
    <>
      {/* {props.iconOnly && <img src={props.iconSrc} />} */}
      {props.iconOnly && <props.buttonIcon className="me-2" />}
      {props.bigButton && (
        <BigButton
          {...props}
          onClick={
            props.checkForPermission
              ? handlePermissionEvent(props.checkForPermission, openModal)
              : openModal
          }
          type="button"
        />
      )}
      {/* product details page upload 24 image logic */}
      {props?.bigIcon && (
        <span
          className="upload-360-img"
          onClick={
            props.checkForPermission
              ? handlePermissionEvent(props.checkForPermission, openModal)
              : openModal
          }>
          {props?.iconBefore}
        </span>
      )}
      {props.miniButton && (
        <MiniButton
          title={props.buttonTitle}
          clickFunction={() => toggleModal(true)}
          iconSrc={props.iconSrc}
          buttonLabel={props.buttonLabel}
        />
      )}
      {props.footerButton && (
        <FooterButton icon={props.buttonIcon} {...props} clickFunction={() => toggleModal(true)} />
      )}
      {props.button}
      <ModalArea
        handleOwnerClose={props.handleOwnerClose}
        ownerModal={props.ownerModal}
        showModal={_.isBoolean(props.showModal) ? props.showModal : showModal}
        setShowModal={toggleModal}
        className={cx(props.className, props.modalClassName)}
        title={props?.dialogTitle || props.title}
        subtitle={props.subtitle}
        body={props.body}
        animation={props.animation}
        includeCancelButton={props.includeCancelButton}
        cancelBtnClassname={props.cancelBtnClassname}
        promptButton={props.promptButton}
        size={props?.size}
        centered={props.centered}
        backdrop={props?.backdrop}
        backdropClassName={props.backdropClassName}
        headingLeft={props.headingLeft}
        parentClassName={props.parentClassName}
        bodyClassName={props.bodyClassName}
        headerClassName={props.headerClassName}
        onCloseModal={props?.onCloseModal}
        isCloseModal={props?.isCloseModal}
        contentClassName={props.contentClassName}
        enforceFocus={props?.enforceFocus}
        closeIconV2={props?.closeIconV2}
      />
    </>
  );
};

ModalButtonArea.defaultProps = {
  centered: true,
};

export default ModalButtonArea;
